// Shared minimal markdown -> HTML renderer (no external deps).
//
// Extracted verbatim from the copies that lived in SummaryTab.tsx and
// pages/CaseDetail.tsx so every consumer uses ONE renderer. Good enough
// for the structured markdown the backend produces (headers, bold/italic,
// inline code, ordered/unordered lists, horizontal rules, paragraphs).

export function renderMarkdown(md: string): string {
  let html = md
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  html = html.replace(/^#{6}\s+(.+)$/gm, '<h6 class="text-sm font-semibold text-slate-700 mt-6 mb-1">$1</h6>');
  html = html.replace(/^#{5}\s+(.+)$/gm, '<h5 class="text-sm font-semibold text-slate-700 mt-6 mb-1">$1</h5>');
  html = html.replace(/^#{4}\s+(.+)$/gm, '<h4 class="text-sm font-semibold text-slate-700 mt-8 mb-2">$1</h4>');
  html = html.replace(/^#{3}\s+(.+)$/gm, '<h3 class="text-base font-semibold text-slate-800 mt-8 mb-3">$1</h3>');
  html = html.replace(/^#{2}\s+(.+)$/gm, '<h2 class="text-lg font-bold text-slate-800 mt-10 mb-3">$1</h2>');
  html = html.replace(/^#\s+(.+)$/gm, '<h1 class="text-xl font-bold text-slate-900 mt-10 mb-3">$1</h1>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/`([^`]+)`/g, '<code class="text-xs bg-slate-100 px-1 rounded">$1</code>');
  // Markdown links: [label](url) -> clickable hyperlink (URL hidden behind label).
  html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" class="text-primary-600 underline" target="_blank" rel="noopener noreferrer">$1</a>');
  html = html.replace(/^(\s*)[-\*]\s+(.+)$/gm, '<li class="ml-4 text-sm text-slate-700">$2</li>');
  html = html.replace(/(<li[^>]*>.*<\/li>)/gs, (m) => '<ul class="space-y-0 mt-1 mb-4">' + m + '</ul>');
  html = html.replace(/(<\/li>)\s*\n+(\s*<li)/g, '$1$2');
  html = html.replace(/^\d+\.\s+(.+)$/gm, '<li class="ml-4 text-sm text-slate-700 list-decimal">$1</li>');
  html = html.replace(/^---+$/gm, '<hr class="border-slate-200 my-4" />');
  html = html.replace(/\n\n/g, '</p><p class="text-sm text-slate-700 leading-relaxed mb-4">');
  html = html.replace(/\n/g, '<br/>');
  html = '<p class="text-sm text-slate-700 leading-relaxed mb-3">' + html + '</p>';
  return html;
}